<template>
  <div>
    <div class="mb-10px text-right" v-if="formData.workflowDelayTaskId">
      <el-button size="mini" @click="viewProcess(formData)">查看流程</el-button>
    </div>
    <el-form ref="formData" label-width="150px" :model="formData" disabled>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item
            label="隐患整改延期申请人"
            prop="hiddenDangerRectificationExtensionApplicantId"
          >
            <person-select
              :disabled="true"
              v-model="formData.hiddenDangerRectificationExtensionApplicantId"
            ></person-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item label="原有计划整改期限时间" prop="hiddenDangerRectificationPeriod">
            <el-date-picker
              class="!w-full"
              v-model="formData.hiddenDangerRectificationPeriod"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请输入原有计划整改期限时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item label="计划延期整改时间" prop="deferralTime">
            <el-date-picker
              class="!w-full"
              v-model="formData.deferralTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="计划延期整改时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item label="隐患整改延期原因" prop="hiddenDangersRectificationDelayReason">
            <el-input
              v-model="formData.hiddenDangersRectificationDelayReason"
              placeholder="请输入隐患整改延期原因"
              maxlength="500"
              show-word-limit
              clearable
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form-item label="隐患当前控制措施" prop="hiddenDangerVerifierOpinions">
            <el-input
              v-model="formData.hiddenDangerVerifierOpinions"
              placeholder="请输入隐患当前控制措施"
              maxlength="500"
              show-word-limit
              type="textarea"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 查看流程start -->
      <ApprovalFlowDialog
        :visible.sync="showFlowDialog"
        v-if="showFlowDialog"
        :id="formData.workflowDelayTaskId"
      ></ApprovalFlowDialog>
      <!-- 查看流程end -->
    </el-form>
  </div>
</template>

<script>
import uuid from 'uuid'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'

const areaApi = new AreaApi()

export default {
  name: 'hidden-postpone-view',
  components: {
    PersonSelect,
    ApprovalFlowDialog,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'read',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo'],
      showFlowDialog: false, // 是否显示审批流程页面
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
          this.formData.currentControlMeasures = this.formData.hiddenDangerVerifierOpinions || ''
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
      ],
      ['hiddenLevelList', 'hiddenTypeList', 'hiddenCategoryList'],
      this
    )
  },
  mounted() {},

  methods: {
    viewProcess() {
      if (
        typeof this.formData.workflowDelayTaskId === 'string' &&
        _.includes(this.formData.workflowDelayTaskId, '-')
      ) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.formData.workflowDelayTaskId)
        return
      }
      this.showFlowDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
